import Button from 'src/components/atoms/Button';
// import Logo from 'src/logos/Logo'
import css from './SignupFinish.module.scss';
import css2 from './shared.module.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import { setBranch } from 'src/slices/auth'
import { setStep } from 'src/slices/signup';
import { clearCurrentMarker } from 'src/slices/location';
import Logo from 'src/logos/Logo';

export default function SignupFinish(params) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { currBranch, token } = useSelector(state => state.auth)
  // const { user } = useSelector(state => state.signup)
  const handleNext = () => {
    // if (!currBranch) {
    navigate('/login');
    dispatch(setStep(0));
    dispatch(clearCurrentMarker());
    // }
  };
  return (
    <div className={css['page']}>
      <Logo width='260px' />
      <div>
        <i className={`fas fa-check ${css.icon}`} />

        <h1>Thank you for signing up as a Livecart merchant</h1>
        <p>
          Your account has been created successfully. Please check your email address for the
          verification link we sent you.
          <br />
          When you log in, be sure to complete the banking information for your account so you can
          start selling items!
        </p>

        <div className={css2['buttons']}>
          <Button
            label={'Go to Login'}
            variant="primary"
            color="teal"
            // iconRight='fa fa-chevron-right'
            action={handleNext}
          />
        </div>
      </div>
    </div>
  );
}
